export class Role {
    static ADMIN: string = "ADMIN";
    static OPERATOR: string = "OPERATOR";
}


// WEBPACK FOOTER //
// ./src/app/api/Role.ts